import React from "react";
import ReactStars from "react-rating-stars-component";

const StarRating = ({ onClick, size, ratingTimes }) => {
  return (
    <>
      {ratingTimes.map((d, i) => (
        <div className="rating" key={i + 1} onClick={()=>onClick(d)}>
          <ReactStars
            count={d}
            size={size}
            edit={false}
            activeColor="red"
            color="#ffd700"
            style={{cursor: "pointer !important"}}
          />
        </div>
      ))}
    </>
  );
};

export default StarRating;
